import { InfluencerProfileOverview, InfluencerProfileOverviewProps } from '../shared';

type InfluencerYoutubeProfileOverviewProps = InfluencerProfileOverviewProps;

export const InfluencerYoutubeProfileOverview = (props: InfluencerYoutubeProfileOverviewProps) => (
  <InfluencerProfileOverview {...props} />
);
